import { render, staticRenderFns } from "./add-schedule-duty.vue?vue&type=template&id=72df5928"
import script from "./add-schedule-duty.vue?vue&type=script&lang=js"
export * from "./add-schedule-duty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports